import React, {} from 'react';

import { useSlateStatic } from 'slate-react';

import nodeControls from '../../node-menu/control-types';
import BaseElement from '../base';

import { determineBaseProperties } from '../utilities';

import './index.scss';

function YoutubeVideo(props) {

  const element = props.element;

  const baseElementProperties = determineBaseProperties({
    ...props,
    customNodeControls: [
      nodeControls.ALIGNMENT
    ]
  }, nodeControls);

  function renderInput() {

    return <iframe
      title="YoutubeVideo"
      width="100%"
      height="100%"
      src={`https://www.youtube.com/embed/${element.properties.videoId}`}
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullscreen
    ></iframe>;

  }

  function renderMain() {

    const attributes = {
      ...props.attributes,
      className: 'youtube-video-main',
      contentEditable: false
    };

    return <div {...attributes}>
      {renderInput()}
      {props.children}
    </div>;

  }

  return <BaseElement {...baseElementProperties}>
    {renderMain()}
  </BaseElement>;

}

export default YoutubeVideo;